<template>
  <main class="shop_profile_info">
    <div class="info_profile_img" v-if="shop.storeProfileImage">
      <img :src="shop.storeProfileImage" alt="" />
    </div>
    <div class="info_profile_img" v-else>
      <img :src="setShopProfileImg(shop.name, shop.id)" alt="" />
    </div>
    <div class="info_shop_1">
      <div class="shop_name">{{ shop.name }}</div>
      <div class="shop_score">
        <div class="score_star">
          <img :src="require(`@/assets/front/images/i_star_on.svg`)" alt="" />
        </div>

        <div class="score_cnt">
          {{ Number(shop.evaluationScore).toFixed(1) }}점({{
            shop.reviewCnt
          }}건)
        </div>
      </div>
    </div>
    <div class="info_shop_2">
      <div class="shop_i_wrap">
        <div class="shop_li">
          <div class="i_title">상담</div>
          <div class="i_txt_1 lh">{{ shop.chatCnt }}건</div>
        </div>
        <div class="shop_li">
          <div class="i_title">인터넷 개통</div>
          <div class="i_txt_1 lh">{{ shop.internetSaleCnt }}건</div>
        </div>
        <div class="shop_li">
          <div class="i_title">응답률</div>
          <div class="i_txt_1" v-if="shop.chatCnt > 0 && shop.responseRate > 0">
            {{ shop.responseRate > 100 ? 100 : shop.responseRate }}%
          </div>
          <div v-else class="i_txt_1 lh">-</div>
          <div
            class="i_txt_2"
            v-if="
              shop.responseMinute > 0 &&
                shop.responseMinute <= 10 &&
                shop.chatCnt > 0 &&
                shop.responseRate > 0
            "
            style="margin-left:0.2rem"
          >
            (10분 이내)
          </div>
          <div
            class="i_txt_2"
            v-if="
              shop.responseMinute > 10 &&
                shop.responseMinute <= 30 &&
                shop.chatCnt > 0 &&
                shop.responseRate > 0
            "
            style="margin-left:0.2rem"
          >
            (30분 이내)
          </div>
          <div
            class="i_txt_2"
            v-if="
              shop.responseMinute > 30 &&
                shop.responseMinute <= 60 &&
                shop.chatCnt > 0 &&
                shop.responseRate > 0
            "
            style="margin-left:0.2rem"
          >
            (1시간 이내)
          </div>
          <div
            class="i_txt_2"
            v-if="
              shop.responseMinute > 60 &&
                shop.responseMinute <= 120 &&
                shop.chatCnt > 0 &&
                shop.responseRate > 0
            "
            style="margin-left:0.2rem"
          >
            (2시간 이내)
          </div>
          <div
            class="i_txt_2"
            v-if="
              shop.responseMinute > 120 &&
                shop.responseMinute <= 360 &&
                shop.chatCnt > 0 &&
                shop.responseRate > 0
            "
            style="margin-left:0.2rem"
          >
            (6시간 이내)
          </div>
          <div
            class="i_txt_2"
            v-if="
              shop.responseMinute > 360 &&
                shop.chatCnt > 0 &&
                shop.responseRate > 0
            "
            style="margin-left:0.2rem"
          >
            (6시간 이상)
          </div>
        </div>
      </div>
    </div>
    <div class="info_shop_3">
      <div class="shop_i_wrap">
        <div class="i_img">
          <img
            :src="
              require(`@/assets/front/images/v2/profiles/ic_profile_clock.svg`)
            "
            alt=""
          />
        </div>
        <div class="i_title">상담 가능 시간</div>
        <div
          class="i_txt"
          v-if="shop.counselStart == '00:00' && shop.counselEnd == '24:00'"
        >
          종일
        </div>
        <div class="i_txt" v-else>
          {{ shop.counselStart }} ~ {{ shop.counselEnd }}
        </div>
      </div>
      <div class="shop_i_wrap">
        <div class="i_img">
          <img
            :src="
              require(`@/assets/front/images/v2/profiles/ic_profile_bookmark.svg`)
            "
            alt=""
          />
        </div>
        <div class="i_title">관심 매장 등록</div>
        <div class="i_txt">{{ shop.followCnt }}건</div>
      </div>
      <div class="shop_i_wrap">
        <div class="i_img">
          <img
            :src="
              require(`@/assets/front/images/v2/profiles/ic_profile_address.svg`)
            "
            alt=""
          />
        </div>
        <div class="i_title">매장 주소</div>
        <div class="i_txt">
          {{ shop.address }}
          <div class="shop_address_copy" @click="setAddrCopy">
            <img
              :src="require(`@/assets/front/images/new/i_copy.svg`)"
              class="i_address_copy"
            />복사
          </div>
          <input
            type="text"
            :value="shop.address"
            id="address_input"
            inputmode="none"
          />
        </div>
      </div>
    </div>
    <div class="info_shop_4">
      <div class="map_area pnt" @click="openStoreMap">
        <ShopMap
          v-if="isShowShop"
          :lat="shop.latitude"
          :lng="shop.longitude"
          :is-draggable="false"
        />
        <div class="map_area_wrap"></div>
      </div>
    </div>
    <!-- 사장님 -->
    <div class="info_shop_5" v-if="!isCustomer">
      <div
        class="shop_consent_wrap pnt"
        @click="goLink('Shops.PriorConsentForm')"
        v-if="isConsentView"
      >
        <div class="shop_consent_1" v-if="!priorConsentCheck">
          <div class="cons_1">
            <div class="cons_1_1">
              <div class="cons_img">
                <img
                  :src="
                    require(`@/assets/front/images/new/icon_consent_noti.png`)
                  "
                  alt=""
                />
              </div>
              <div class="cons_txt_wrap">
                <div class="cons_txt_1">
                  <span>판매점 사전승낙</span> 또는
                  <span>대리점 인증마크</span>를
                  <br />
                  등록하고 고객의 신뢰를 받아보세요!
                </div>
                <div class="cons_txt_2">
                  (승낙마크가 없으면 활동에 제한을 받습니다!)
                </div>
              </div>
            </div>
            <div class="cons_1_2">
              <div class="cons_img_1">
                <img
                  :src="require(`@/assets/front/images/new/i_exc_red.png`)"
                  alt=""
                />
              </div>
              <div class="cons_img_2">
                <img
                  :src="require(`@/assets/front/images/new/ar_main_sec_w.png`)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="shop_consent_2" v-else>
          <div class="cons_1">
            <div class="cons_1_1">
              <div class="cons_img">
                <img
                  :src="require(`@/assets/front/images/new/icon_consent_s.png`)"
                  alt=""
                />
              </div>
              <div class="cons_txt_wrap">
                <div class="cons_txt_1">
                  국가승인 사전승낙서등록 매장입니다!
                </div>
                <div class="cons_txt_2" v-if="existPriorConsentLabels">
                  ({{ existPriorConsentLabels.toString().replace(/,/g, ', ') }})
                </div>
              </div>
            </div>
            <div class="cons_1_2">
              <div class="cons_img_2">
                <img
                  :src="require(`@/assets/front/images/new/ar_main_sec_w.png`)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 사용자 -->
    <div class="info_shop_5" v-else>
      <div
        class="shop_consent_wrap pnt mb_1"
        @click="goPriorConsentView"
        v-if="isConsentView && priorConsentCheck"
      >
        <div class="shop_consent_2">
          <div class="cons_1">
            <div class="cons_1_1">
              <div class="cons_img">
                <img
                  :src="require(`@/assets/front/images/new/icon_consent_s.png`)"
                  alt=""
                />
              </div>
              <div class="cons_txt_wrap">
                <div class="cons_txt_1">
                  국가승인 사전승낙서등록 매장입니다!
                </div>
              </div>
            </div>
            <div class="cons_1_2">
              <div class="cons_img_2">
                <img
                  :src="require(`@/assets/front/images/new/ar_main_sec_w.png`)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="shop_consent_wrap pnt"
        @click="popupOpen"
        v-if="shop.internetGuaranteed > 0"
      >
        <div class="shop_consent_2">
          <div class="cons_1">
            <div class="cons_1_1">
              <div class="cons_img">
                <img
                  :src="
                    require(`@/assets/front/images/v2/icons/ic_guarantee.png`)
                  "
                  alt=""
                />
              </div>
              <div class="cons_txt_wrap">
                <div class="cons_txt_1">
                  퍼스지급보장 매장입니다!
                </div>
              </div>
            </div>
            <div class="cons_1_2">
              <div class="cons_img_2">
                <img
                  :src="require(`@/assets/front/images/new/ar_main_sec_w.png`)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="made_toast" v-if="isViewToast">
        <div class="toast_msg">주소가 복사 되었습니다.</div>
      </div>
    </transition>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '퍼스지급보장 매장이란?',
        type: 'alert',
        msg: msg,
      }"
      @close="popupClose"
    />
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

import ShopMap from '@/common/components/shop/ShopMap';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';

export default {
  name: 'ShopProfileInfo',
  props: {
    shop: Object,
    isShowShop: Boolean,
    isConsentView: Boolean,
    priorConsentCheck: Boolean,
    existPriorConsentLabels: Array,
    isCustomer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ShopMap,
    DesignPopup2,
  },
  data() {
    return {
      isViewToast: false,
      designPopup: false,
      msg:
        '<img src="' +
        require('@/assets/front/images/v2/tag_guarantee.png') +
        '" style="width:8.9rem;height:auto;text-align:center;display:inline-block;" /><br />퍼스지급보장 제도는 퍼스지급보장 마크가<br />있는 매장에서 인터넷 가입 시,<br /> 고객이 약속된 지원금을 받지 못할 경우<br />퍼스가 대신 지급해주는 제도입니다.',
    };
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '140x140');

      return path;
    },
    openStoreMap() {
      this.$router.push({
        name: 'Shops.location',
        params: { id: this.shop.id },
      });
    },
    goLink(link) {
      this.$router.push({
        name: link,
      });
    },
    goPriorConsentView() {
      this.$router.push({
        name: 'Shops.priorConsent',
        query: {
          id: this.shop.id,
        },
      });
    },
    setAddrCopy() {
      console.log('copy');

      const copyText = document.getElementById('address_input');
      copyText.select();
      document.execCommand('copy');
      this.isViewToast = true;
      setTimeout(() => {
        this.isViewToast = false;
      }, 2000);
    },
    popupOpen() {
      this.designPopup = true;
    },
    popupClose() {
      this.designPopup = false;
    },
  },
};
</script>
